import routes from "@/router/routes";
import store from "@/store/index";
import auth_util from "@/utils/auth";
import { createRoutesUtil } from "./routes";

// Export a function that takes the router and returns the util
export function getRoutesUtil(router) {
    return createRoutesUtil({ router, store, auth_util, routes });
}
